
import { Component, Vue } from 'vue-property-decorator'
import { openGlobalCustomerService } from '@/utils/global-customer-service'
@Component({
    name: 'BottomBtn'
})
export default class extends Vue {
    private questionFeedback() {
        this.$jump('/feedback')
    }
    private openGlobalCustomerService() {
        openGlobalCustomerService()
    }
}
